export default class CustomerPhoneNumber {
  constructor (customerId, type) {
    this.actions = {
      create: 'createCustomerPhoneNumber',
      update: 'updateCustomerPhoneNumber',
      remove: 'deleteCustomerPhoneNumber'
    }

    this.requestData = { customerId, type }
    this.name = 'phoneNumber'
  }

  isNew (data) {
    return data.id === null || data.id === undefined
  }

  isEmpty (data) {
    return data.number === '' || data.number === null || data.number === undefined
  }

  static empty () {
    return { number: '', label: '', id: null }
  }

  static parse (data) {
    return {
      id: data.id,
      label: data.label || '',
      number: data.number || ''
    }
  }

  static parseResponseData (response) {
    let number = response.phoneNumbers

    response.phoneNumbers = (number && number.data && number.data.length > 0)
      ? number.data.map(CustomerPhoneNumber.parse)
      : []

    return response
  }
}
